const buttonTimeActions = {
  text: 'Enviar'
};

export default buttonTimeActions;
